import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../App.css';

const Video = () => {
    const [data, setData] = useState([]);

    const shuffleArray = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            const options = {
                method: 'GET',
                url: 'https://free-football-soccer-videos.p.rapidapi.com/',
                headers: {
                  'X-RapidAPI-Key': '3a1f5c1448msh76651723dbbc972p1224a1jsn4f654d29b46a',
                  'X-RapidAPI-Host': 'free-football-soccer-videos.p.rapidapi.com'
                }
            };

            try {
                const response = await axios.request(options);
                console.log(response.data[0].embed)
                const videos = response.data;
                shuffleArray(videos);
                setData(videos.slice(0, 6));  // Get the first 3 from the shuffled array
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, []);

    return (
        <div className='video-container'>
 
            {data.map((video, index) => (
                <div className='video' key={index} dangerouslySetInnerHTML={{ __html: video.embed }} />
            ))}
        </div>
    );
};

export default Video;
